<template>
  <v-form ref="form" @submit.prevent>
    <v-container class="px-8">
      <v-row no-gutters justify="center">
        <v-col cols="12" md="8">
          <h2 class="loginTheme--text">Recuperar Senha</h2>
        </v-col>
        <v-col cols="12" md="8">
          <h4 class="mt-5 font-weight-light">
            Preencha o campo abaixo com seu email e enviaremos instruções para redefinir sua senha
          </h4>
        </v-col>
        <v-col cols="12" md="8" class="mt-10">
          <v-text-field
            v-model="email"
            @keydown.space.prevent
            :rules="[
              v => !!(v || '').trim() || 'Email é obrigatório',
              v => regex.test((v || '').trim().toLowerCase()) || 'Email inválido'
            ]"
            outlined
            color="loginTheme"
            label="Digite seu email"
            autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-btn @click="submit" type="submit" class="mt-5" color="loginTheme" dark rounded block large>Enviar</v-btn>
        </v-col>
        <v-col cols="12" md="8">
          <v-btn @click="$router.go(-1)" class="mt-3" color="loginTheme" outlined rounded block large>Voltar</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import authenticationService from '@/services/authentication'
import { emailRegex } from '@/utils/constants'

export default {
  data: () => ({
    email: '',
    regex: new RegExp(emailRegex)
  }),
  watch: {
    email(newValue) {
      const formattedValue = (newValue || '').toLowerCase().replace(/\s/g, '')
      if (newValue !== formattedValue) {
        this.email = formattedValue
      }
    }
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return

      this.$showLoading()
      try {
        const { data } = await authenticationService.recuperarSenha(this.email, window.location.origin)
        const { message } = data

        this.$showSuccessMessage(message)

        this.$router.push({ name: 'Login' })
      } catch (error) {
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.$hideLoading()
      }
    }
  }
}
</script>

<style></style>
